import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const contactInfo = [
    {
      icon: 'ri-phone-line',
      title: 'Telefon',
      info: '0505 605 58 45',
      subInfo: '0554 116 69 76'
    },
    {
      icon: 'ri-mail-line',
      title: 'E-posta',
      info: 'info@ybhukukdanismanlik.com',
      subInfo: '24 saat içinde yanıt'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Adres',
      info: 'Çelebiler Mah. 119. Cad. No : 1 D : 6',
      subInfo: 'Merkez / ISPARTA'
    }
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    // Validate required fields
    if (!formData.name || !formData.email || !formData.subject) {
      setSubmitMessage('Lütfen tüm zorunlu alanları doldurun.');
      setIsSubmitting(false);
      return;
    }

    // Validate message length
    if (formData.message && formData.message.length > 500) {
      setSubmitMessage('Mesaj 500 karakterden fazla olamaz.');
      setIsSubmitting(false);
      return;
    }

    try {
      const formDataToSend = new URLSearchParams();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('phone', formData.phone);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('subject', formData.subject);
      formDataToSend.append('message', formData.message);

      await fetch('https://readdy.ai/api/form/d3ipdtp5ls7rqlnfii20', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString()
      });

      // Success message
      setSubmitMessage('Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.');
      setFormData({
        name: '',
        phone: '',
        email: '',
        subject: '',
        message: ''
      });

    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitMessage('Bir hata oluştu. Lütfen tekrar deneyin.');
    }

    setIsSubmitting(false);
  };

  return (
    <section className="py-16 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 font-poppins">
            İletişim
          </h2>
          <div className="w-16 h-0.5 bg-white mx-auto mb-6"></div>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto font-poppins font-light">
            Hukuki danışmanlık ihtiyaçlarınız için bizimle iletişime geçin
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="animate-slide-in-left">
            <h3 className="text-2xl font-bold mb-6 font-poppins">
              Bize Ulaşın
            </h3>
            <div className="space-y-6">
              {contactInfo.map((item, index) => (
                <div 
                  key={index} 
                  className="flex items-start animate-fade-in-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className={`${item.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1 font-poppins">{item.title}</h4>
                    <p className="text-gray-300 font-poppins font-light">{item.info}</p>
                    <p className="text-gray-400 text-sm font-poppins font-light">{item.subInfo}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="animate-slide-in-right">
            <form id="anasayfa-iletisim-formu" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium mb-2 font-poppins">Ad Soyad *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-white/40 font-poppins font-light"
                    placeholder="Adınız ve soyadınız"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2 font-poppins">Telefon</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-white/40 font-poppins font-light"
                    placeholder="Telefon numaranız"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 font-poppins">E-posta *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-white/40 font-poppins font-light"
                  placeholder="E-posta adresiniz"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 font-poppins">Konu *</label>
                <select 
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white focus:outline-none focus:border-white/40 pr-8 font-poppins font-light"
                  required
                >
                  <option value="">Konu seçiniz</option>
                  <option value="ticaret">Ticaret Hukuku</option>
                  <option value="aile">Aile Hukuku</option>
                  <option value="gayrimenkul">Gayrimenkul Hukuku</option>
                  <option value="ceza">Ceza Hukuku</option>
                  <option value="is">İş Hukuku</option>
                  <option value="fikri">Fikri Mülkiyet</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 font-poppins">Mesaj</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-white/40 resize-none font-poppins font-light"
                  placeholder="Mesajınızı yazın... (Maksimum 500 karakter)"
                ></textarea>
                <div className="text-right text-xs text-gray-400 mt-1 font-poppins">
                  {formData.message.length}/500
                </div>
              </div>

              {submitMessage && (
                <div className={`p-3 rounded-lg text-sm font-poppins ${
                  submitMessage.includes('başarıyla') 
                    ? 'bg-green-100 text-green-700' 
                    : 'bg-red-100 text-red-700'
                }`}>
                  {submitMessage}
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-white text-slate-900 py-3 px-6 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap font-poppins disabled:opacity-50 cursor-pointer"
              >
                {isSubmitting ? 'Gönderiliyor...' : 'Mesaj Gönder'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
